// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderListItemList_root__BUWPl"};